import "esbuild-css-modules-plugin-ns-css:src/js/components/underlineButton/underlineButton.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/components/underlineButton/underlineButton.module.css:injector.js";
export default new Proxy({
  "buttonContainer": "underlineButton-module__buttonContainer_sZYRJG__1100",
  "buttonText": "underlineButton-module__buttonText_sZYRJG__1100",
  "disabled": "underlineButton-module__disabled_sZYRJG__1100",
  "hidden": "underlineButton-module__hidden_sZYRJG__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      